export const IconProps = {
  size: 24,
  color: 'currentColor',
  className: '',
}; 